export const addressApiQuery = `
    query addressLookup( $req:AddressLookupInput, ) {
      addressLookup(input: $req) {
        __typename
        ... on AddressLookupResponse {
          results {
            addressLine1
            addressLine2
            city
            countryCode
            postalCode
            rawAddress
            stateCode
            stateName
            type
          }
        }
        ... on ErrorResponse {
          errorCode
          message
          name
        }
      }
    }`;
